// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__ctNwU","card":"styles_card__dl9a2","accordionToggle":"styles_accordionToggle__aZvd1","white":"styles_white__D0SJW"};